import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {UIRouterModule} from '@uirouter/angular';
import { QuestionnairePrintReportComponent } from './questionnaire-print.component';
import { QuestionnairePrintReportStates } from './questionnaire-print.states';

@NgModule({
    imports: [
        CommonModule,
        UIRouterModule.forChild({
            states: QuestionnairePrintReportStates
        })
    ],
    declarations: [
        QuestionnairePrintReportComponent
    ]
})
export class QuestionnairePrintReportModule {}